module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAJCAYAAACc9xrJAAAABGdBTUEAALGPC/xhBQAAAMBJREFUSA1jYBjh4P///w5AXALEuiM8KEjzPjDAdgAxDDwFMuYDcTgQC5Nm0ghTDQygs0AMAh8gFJz8C2SdBOImILYGYhbkoGEECuxHFhiBbGOgn3mB+CwQcwGxIhBzADE6+AEUuA/E34DYARRw/9FVjPIJhoAMKPkdIKhseCsgJ8V9HN5BQoTvgBmOrDIOpcAjwp7hrIQf6LlnQLwLiHcA8R5GRsa3QBorYMQqOoIEgSnOGuhdTSA+CQyoy8R6HQDtF5Cjoy5LGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/share/djtsx_d.png
// module id = 374
// module chunks = 0